import React, { useState } from 'react';
import {
  Button,
  Col,
  Row,
  TabContent,
  TabPane,
  Container,
  Card,
} from 'reactstrap';
import AddNewProjectComponents from '../../Components/PMComponents/AddNewProjectComponents';
import PMProjectListComponents from '../../Components/PMComponents/PMProjectListComponents';
import PMDashComponents from '../../Components/PMComponents/PMDashComponents';
import TeamLeadview from '../../Components/PMComponents/PMTeamLeadview';

const PMDashboard: React.FC = () => {
  const [refresh, setRefresh] = useState(false);
  const [showAddProject, setShowAddProject] = useState(false);
  const [activeTab, setActiveTab] = useState("Dashboard");

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Container fluid className="mt-4">
      <Row className="mt-4 justify-content-center" >
        {/* Sidebar Navigation */}
        <Col sm={12} className="d-flex flex-wrap justify-content-center gap-3 mb-3">
                <Button tag="button" action onClick={() => toggleTab("Dashboard")} active={activeTab === "Dashboard"} 
                color="primary"
                outline
                className="tab-btn1">
                  Dashboard
                </Button>
                <Button tag="button" action onClick={() => toggleTab("Projects")} active={activeTab === "Projects"}
                  color="primary"
                        outline
                        className="tab-btn1">
                  Projects
                </Button>
                 {/* <Button tag="button" action onClick={() => toggleTab("Settings")} active={activeTab === "Settings"}
                  color="primary"
                        outline
                        className="tab-btn1">
                  Teamlead View
                </Button>  */}
        </Col>

        {/* Main Content */}
        <Col md={10}>
          <TabContent activeTab={activeTab}>
            {/* Dashboard Tab */}
            <TabPane tabId="Dashboard">
              <Card className="shadow-sm">
             <PMDashComponents/>
              </Card>
            </TabPane>

            {/* Projects Tab */}
            <TabPane tabId="Projects">
              <div className='mb-3 text-end'>
                <Button color="success" onClick={() => setShowAddProject(!showAddProject)}>
                   <b> {showAddProject ? 'Close' : '+'} </b> 
                  </Button>
                  </div>


              {showAddProject && (
                <AddNewProjectComponents
                  onProjectAdd={() => {
                    setShowAddProject(false);
                    setRefresh(!refresh);
                  }}
                />
              )}

                  <PMProjectListComponents refreshTrigger={refresh}/>
            </TabPane>

            {/* Settings Tab */}
            <TabPane tabId="Settings">
              <Card className="shadow-sm">
                <TeamLeadview/>
              </Card>
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </Container>
  );
};

export default PMDashboard;
